module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_materialParams.1001.jpg.5b5fec85.webp";